// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"251":"ffacd510fe9a13c1ca72","728":"8ff683ab3ea50043d5cd"}[chunkId] + ".js";
};